import apiClient from '@/utils/apiClient'
import GetSupplierOrderByIdController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/GetSupplierOrderByIdController'
import GetCateringSupplierOrderByDossierController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/GetCateringSupplierOrderByDossierController'
import ReceiveSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/ReceiveSupplierOrderController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  async fetchAllSupplierOrders({ commit }) {
    await apiClient
      .get('/api/supplier-order')
      .then(async (response) => {
        await commit('setInvoiceIndex', response.data.supplier_orders)
        // await commit('setInvoiceMetadata', response.data.metadata)
      })
      .catch((reason) => {
        console.error('setErrors fetchAllSupplierOrders', reason)
      })
  },
  fetchSupplierOrderByID: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      return apiClient
        .route(
          GetSupplierOrderByIdController.get({ supplier_order: payload.id })
        )
        .then((response) => {
          if (payload.supplier_order_index !== null) {
            commit('setInvoiceAtIndex', {
              index: payload.supplier_order_index,
              invoice: response.data.supplier_order
            })
          } else {
            commit('setInvoice', response.data.supplier_order)
            commit('setInvoiceMetadata', response.data.metadata)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewSupplierOrder({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'supplierOrder' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async fetchDraftSupplierOrderBySupplierId({ commit }, payload) {
    await apiClient
      .get(`/api/invoicing/draft-supplier-order/${payload.supplier_id}`)
      .then(async (response) => {
        if (response.status === 200) {
          commit('setInvoiceIndex', response.data.invoices)
        }
      })
      .catch(async (reason) => {
        await console.error('fetchDraftSupplierOrderBySupplierId', reason)
      })
  },

  async fetchCateringSupplierOrderByDossierId({ commit }, payload) {
    await apiClient
      .route(
        GetCateringSupplierOrderByDossierController.get({
          dossier: payload.dossier_id
        })
      )
      .then(async (response) => {
        if (response.status === 200) {
          commit('setInvoiceIndex', response.data.invoices)
        }
      })
      .catch(async (reason) => {
        await console.error('fetchCateringSupplierOrderByDossierId', reason)
      })
  },

  async receiveOrder({ commit }, payload) {
    await apiClient
      .route(
        ReceiveSupplierOrderController.put({
          supplier_order: payload.supplier_order_id
        }),
        payload.reception
      )
      .then(async (response) => {
        await console.log('retrieveOrder', response)
        if (response.status === 200) {
          processSuccessCallback(payload)
          commit('setInvoiceIndex', response.data.invoices)
        }
      })
      .catch(async (reason) => {
        await console.error('retrieveOrder', reason)
      })
  }
}
